
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import asyncComponent from '../../util/AsyncFunc';

import AddCustomer from './addcustomer/index'
import CustomerList from './customerlist/index'

const Customer = ({ match }) => (
    <div className="app-wrapper">
        {/* {// console.log('match',match)} */}
        <Switch>
            <Redirect exact from={`${match.url}/`} to={`${match.url}/customer-list`} />
            <Route path={`${match.url}/add-customer/:id?`} component={AddCustomer} />
            <Route path={`${match.url}/customer-list`} component={CustomerList} />
        </Switch>
    </div>
);

export default Customer;



// WEBPACK FOOTER //
// ./app/customerdetails/index.js